import api from "./axiosInstance";

const getDataCounts = (token) => {
  return new Promise((resolve, reject) => {
    api
      .get(`/api/dataCounts`, {
        headers: {
          // Security Headers
          "X-XSS-Protection": "1; mode=block",
          Authorization: `Bearer ${token}`,
          "X-Content-Type-Options": "nosniff",
          "X-Frame-Options": "DENY",
          "Referrer-Policy": "strict-origin-when-cross-origin",
          "Permissions-Policy": "camera=(), microphone=(), geolocation=()",

          // Standard Headers
          "Content-Type": "application/json",
        },
      })
      .then((data, err) => {
        if (data) {
          resolve(data);
        } else {
          resolve("error");
        }
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export default getDataCounts;
